import { defineMessages } from 'react-intl';

export default defineMessages({
    underlyingPolicies: {
        id: 'ml.quoteandbind.underlyingPolicies.Underlying Policies',
        defaultMessage: 'Underlying Policies'
    },
    policies: {
        id: 'ml.quoteandbind.underlyingPolicies.Policies',
        defaultMessage: 'Policies'
    },
    yourPolicies: {
        id: 'ml.quoteandbind.underlyingPolicies.Your Policies',
        defaultMessage: 'Your Policies'
    },
    foundPoliciesToBeIncluded: {
        id: 'ml.quoteandbind.underlyingPolicies.We found the policies below to be included under your umbrella coverage',
        defaultMessage: 'We found the policies below to be included under your umbrella coverage'
    },
    noPoliciesIncluded: {
        id: 'ml.quoteandbind.underlyingPolicies.',
        defaultMessage: 'No underlying policies will be included with your umbrella coverage'
    },
    edit: {
        id: 'ml.quoteandbind.underlyingPolicies.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.underlyingPolicies.remove',
        defaultMessage: 'Remove'
    },
    cancel: {
        id: 'ml.quoteandbind.underlyingPolicies.cancel',
        defaultMessage: 'Cancel'
    },
    addPolicy: {
        id: 'ml.quoteandbind.underlyingPolicies.Add Policy',
        defaultMessage: 'Add Policy'
    },
    policyType: {
        id: 'ml.quoteandbind.underlyingPolicies.Policy Type',
        defaultMessage: 'Policy Type'
    },
    carrier: {
        id: 'ml.quoteandbind.underlyingPolicies.Carrier',
        defaultMessage: 'Carrier'
    },
    effectiveDate: {
        id: 'ml.quoteandbind.underlyingPolicies.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'ml.quoteandbind.underlyingPolicies.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    insured: {
        id: 'ml.quoteandbind.underlyingPolicies.Insured',
        defaultMessage: 'Insured'
    },
    actions: {
        id: 'ml.quoteandbind.underlyingPolicies.Actions',
        defaultMessage: 'Actions'
    },
    addAPolicy: {
        id: 'ml.quoteandbind.underlyingPolicies.Add a Policy',
        defaultMessage: 'Add a Policy'
    },
    editPolicy: {
        id: 'ml.quoteandbind.underlyingPolicies.Edit Policy',
        defaultMessage: 'Edit Policy'
    },
    removePolicy: {
        id: 'ml.quoteandbind.underlyingPolicies.Remove Policy',
        defaultMessage: 'Remove Policy'
    },
    removePolicyMessage: {
        id: 'ml.quoteandbind.underlyingPolicies.removePolicyMessage',
        defaultMessage: 'Removing an underlying policy will remove all exposure information with a reference to the policy number. Are you sure you want to proceed?'
    },
    policiesMarkedNeedAttention: {
        id: 'ml.quoteandbind.underlyingPolicies.Policies Marked Need Attention',
        defaultMessage: 'Policies marked with (!) need your attention.'
    },
    ulPolicyErrorAlertMessage: {
        id: 'ml.quoteandbind.underlyingPolicies.ulPolicyErrorAlertMessage',
        defaultMessage: '{policiesNeedAttention} Please click the edit link and fill out all required fields.'
    },
    addPolicyAlertMessage: {
        id: 'ml.quoteandbind.underlyingPolicies.addPolicyAlertMessage',
        defaultMessage: '{policyType} policy from {carrier} has been added.'
    },
    removePolicyAlertMessage: {
        id: 'ml.quoteandbind.underlyingPolicies.removePolicyAlertMessage',
        defaultMessage: '<strong>{policyType}</strong> policy from <strong>{carrier}</strong> has been removed. <a>Undo</a>'
    },
    noAutoUlPolicyErrorAlertMessage: {
        id: 'ml.quoteandbind.underlyingPolicies.noAutoUlPolicyErrorAlertMessage',
        defaultMessage: 'An underlying automobile policy is required for a Personal Umbrella policy.'
    },
    nextDescription: {
        id: 'ml.quoteandbind.underlyingPolicies.nextDescription',
        defaultMessage: 'We\'ll {reviewVehiclesDrivers} next'
    },
    reviewVehiclesDrivers: {
        id: 'ml.quoteandbind.underlyingPolicies.review your vehicles and drivers',
        defaultMessage: 'review your vehicles and drivers'
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.underlyingPolicies.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    }
});
